var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{staticClass:"branchDetail_btn other_btn_4",attrs:{"to":_vm.$route.query.branchId
        ? {
            path: ("/Retail-Outlet/pump/transactions/" + (_vm.data.pumpId)),
            query: {
              pumpId: _vm.data.pumpId,
              startDate: this.$route.query.startDate,
              endDate: this.$route.query.endDate,
              branchId: _vm.data.branchId,
              companyId: _vm.$route.query.companyId,
            },
          }
        : {
            path: ("/Retail-Outlet/pump/transactions/" + (_vm.data.pumpId)),
            query: {
              pumpId: _vm.data.pumpId,
              startDate: this.$route.query.startDate,
              endDate: this.$route.query.endDate,
              companyId: _vm.$route.query.companyId,
            },
          }}},[_vm._v(_vm._s(_vm.data.viewTransactionsButton))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }